import { z } from 'zod'

/**
 * How a couple's day went, in their words. Mirrors `CoupleFeedbackSentiment`
 * (`check:enums`). Not a star rating.
 */
export const COUPLE_FEEDBACK_SENTIMENTS = ['needs_attention', 'wonderful'] as const

export const coupleFeedbackSentimentSchema = z.enum(COUPLE_FEEDBACK_SENTIMENTS)

export type CoupleFeedbackSentiment = z.infer<typeof coupleFeedbackSentimentSchema>
